<template>
  <div class="section-store">
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-sm-4">
          <div class="store-content">
            <h2 class="title">
              Unsere Märkte
            </h2>
            <p>Schauen Sie sich um, entweder hier in unserem Onlineshop oder in einem unserer {{ getInventorySources.length }} Märkte in Deutschland. Unsere Fachberater stehen Ihnen gerne zur Verfügung. Dabei haben Sie die Wahl: online bestellen und nach Hause liefern lassen - oder in einem unserer Märkte die Ware abholen. Ganz wie Sie wünschen.</p>
            <router-link :to="localizedRoute('store')" class="btn btn-sm btn-brown btn-arrow arrow-right-white">
              Unsere Märkte
            </router-link>

            <StoreSelector />
          </div>
        </div>

        <div class="col-xs-12 col-sm-8">
          <div class="store-image">
            <SfImage src="/assets/custom/images/markt-startseite.jpg" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StoreSelector from 'src/modules/vsf-inventory-sources/components/StoreSelector'
import InventorySource from 'src/modules/vsf-inventory-sources/mixins/InventorySource'
import {
  SfImage
} from '@storefront-ui/vue';

export default {
  name: 'MSectionStore',
  mixins: [ InventorySource ],
  components: {
    StoreSelector,
    SfImage
  },
  props: {
  }
};
</script>

<style lang="scss" scoped>
</style>
